import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ms-my-bets-betslip-payout-info',
    template: `
        <vn-icon class="payout-info-icon" name="theme-info-i" size="12" />
        <div>{{ sitecore.earlyPayoutV2.PendingPayoutInfoText }}</div>
    `,
    standalone: false,
})
export class MyBetsBetslipPayoutInfoComponent {
    @HostBinding('class') className = 'my-bets-payout-info';

    constructor(public sitecore: Sitecore) {}
}
